export default __webpack_public_path__ + "static/apercu-medium-af472824a07a25ab90f03f4fe343003d.woff2";